var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"heart\">\n <path d=\"m50 95.82l-6.9727-6.9727c-25.898-22.91-42.832-38.348-42.832-57.277 0-15.438 11.953-27.391 27.391-27.391 8.4688 0 16.934 3.9844 22.414 10.461 5.4688-6.4766 13.945-10.461 22.414-10.461 15.438 0 27.391 11.953 27.391 27.391 0 18.926-16.934 34.367-42.832 57.273z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/heart.icon
// module id = 38
// module chunks = 168707334958949